// extracted by mini-css-extract-plugin
export default {"main":"FlagHeaders_main__laTSG"};